import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Link from "next/link";
import parse from "html-react-parser";
import Grid from "@mui/material/Unstable_Grid2";
import { useEffect } from "react";
import { ProductInfo } from "@/api/product";
import Cookies from "universal-cookie";
import ReactHtmlParser from 'react-html-parser';
import he from "he";
import { useRouter } from "next/router";
import isValid from "date-fns/isValid";
import dayjs from "dayjs";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function createData(title: string, detail: string) {
  return { title, detail };
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      style={{ width: "100%", textAlign: "left" }}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
export default function BasicTabs({ dataSet, dataDetail, dataSpecific }: any) {
  // console.log(dataSpecific);

  const [value, setValue] = React.useState(0);
  const cookies = new Cookies();
  const authToken = cookies.get("token");
  const getToken = authToken !== "" ? authToken : null;
  const [getDataInfo, setGetDataInfo] = React.useState<any>([])
  // console.log(getDataInfo.products.product_stock);
  

  const router = useRouter();
  const sku = router.query.id as any


  const FetchGetproductInfo = async (sku: string, getToken: string) => {
    const res = await ProductInfo(sku, getToken)
    setGetDataInfo(res?.data)
  }

  useEffect(() => {
    FetchGetproductInfo(sku, getToken)
  }, [])


  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const {
    product_quantity = 0, // Provide default values
    product_category = null,
    product_brand = null,
    produc_specific_detail = null,
  } = dataSpecific || {}; // Fallback to an empty object if dataSpecific is null

  const [
    product_id,
    product_type,
    product_tax_invoice_option,
    product_warranty_option,
    product_warranty_period_option,
    product_refund_warranty_condition,
  ] = Array.isArray(dataSet) ? dataSet : [];

  const renderCategoryLinks = () => {
    const lastIndex = product_category?.length - 1;

    return product_category?.map((category: any, index: any) => (
      <React.Fragment key={category.id}>
        <Link
          href={{
            pathname: `/search`,
            query: {
              keyword: "",
              product_type: category.category_type,
              category: category.id as string
            }
          }}
        >
          {category.category_title}
        </Link>
        {index !== lastIndex && " > "}
      </React.Fragment>
    ));
  };

  const rows = [
    createData("หมวดหมู่", renderCategoryLinks()),
    createData(product_brand?.attribute_title, product_brand?.attribute_value),
    createData("จำนวนสินค้า", getDataInfo?.products?.product_stock + " รายการ"),
    ...produc_specific_detail?.map((detail: any) =>
      createData(detail.attribute_title, detail.attribute_value)
    ),
  ];




  const thaiDateFormat = (dateString: any) => {
    if (dateString === "Invalid date") return "ไม่มีวันหมดอายุ";

    const monthNumber = dayjs(dateString).locale('th').add(543, 'year').format('DD/MM/YYYY');

    return ` ${monthNumber.substring(monthNumber.lastIndexOf(" ") + 1)}`;
  };



  useEffect(() => {
    setValue(0)
  }, [router])


  return (
    <>

      <Card variant="outlined" 
        sx={{ 
          minWidth: "100%", 
          // my: { xs: 0, md: 3 }
          mt: 3, mb: 0
        }}
      >
        <Box sx={{ borderBottom: 0 }}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="basic tabs example"
            
            allowScrollButtonsMobile
            TabIndicatorProps={{
              style: {
                backgroundColor: "#994000"
              }
            }}
            sx={{
              '& .MuiTabs-flexContainer': {
                backgroundColor: ' transparent !important',
              },
              '& .Mui-selected': {
                color: '#994000 !important',
                borderColor: '#994000 !important',
              },
              '& .css-1hcww2u': {
                backgroundColor: '#ffffff  !important',
              },
              maxWidth: { xs: 320, sm: 480, md: 600 }, textAlign: "left"
            }}
        
          >
            <Tab label="รายละเอียดสินค้า" {...a11yProps(0)} disableRipple />
            <Tab label="ข้อมูลจำเพาะของสินค้า" {...a11yProps(1)} disableRipple />
          
            {dataSet[0].product_type === "Service" ? (
              <Tab label="การรับประกันและเงื่อนไขบริการ" {...a11yProps(2)} disableRipple />
            ) : (
                <Tab label="การคืนและรับประกันสินค้า" {...a11yProps(2)} disableRipple />
            )}
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <Box sx={{ m: 3 }}>
            {dataDetail?.map((item: any, idx: number) => (
              <Box className="product-detail" key={idx}
              // sx={{width:"50%",height:"auto"}}
              >
                {ReactHtmlParser(ReactHtmlParser(item?.product_detail))}
              </Box>
            ))}
          </Box>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <Box sx={{ m: 0 }}>
            {rows?.map((row) => {
              const isEmptyRow = Object.values(row).some(
                (value) =>
                  value === null || value === "" || value === undefined
              );
              if (isEmptyRow) {
                return null; // Skip rendering the row
              }
              return (
               <>
                  <Box sx={{ m: 3 }}>
                    <Grid container>
                      <Grid xs={6} lg={3}>
                        <Typography className="gray" variant="body2" gutterBottom>
                          {row.title}
                        </Typography>
                      </Grid>
                      <Grid xs={6} lg={9}>
                        <Typography variant="body2" gutterBottom>
                          {row.detail}
                        </Typography>

                      </Grid>
                    </Grid>
                  </Box>
               </>
              );
            })}
          </Box>
        </TabPanel>
        <TabPanel value={value} index={2}>
          {dataSet.map((data: any, idx: number) => (
            <Box key={idx} sx={{ m: 3 }}>
              <Grid container sx={{ mt: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom>
                    ใบกำกับภาษี
                  </Typography>
                </Grid>
                <Grid xs={6} lg={9}>
                  <Typography variant="body2" gutterBottom>
                    {data?.product_tax_invoice_option === 1
                      ? "ออกใบกำกับภาษีไม่ได้"
                      : data?.product_tax_invoice_option === 2
                        ? "ออกใบกำกับภาษีได้"
                        : "ไม่มีใบกำกับภาษี"}
                  </Typography>

                </Grid>
              </Grid>
              <Grid container sx={{ mt: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom>
                    การรับประกันสินค้า
                  </Typography>
                  {data?.product_tax_invoice_option === 2 && (
                    <Typography variant="body2" className="gray" gutterBottom sx={{ mt: 3 }}>
                      ระยะเวลาการรับประกัน
                    </Typography>
                  )}
                </Grid>
                <Grid xs={6} lg={9}>
                  <Typography className="gray" variant="body2" gutterBottom>
                    {data?.product_tax_invoice_option === 1
                      ? "ไม่รับประกัน"
                      : data?.product_tax_invoice_option === 2
                        ? "รับประกัน"
                        : "ไม่มีการรับประกันสินค้า"}
                  </Typography>
                  {data?.product_tax_invoice_option === 2 && (
                    <Typography variant="body2" gutterBottom sx={{ mt: 5 }}>
                      {data?.product_warranty_period_option} วัน
                    </Typography>
                  )}
                </Grid>
              </Grid>


              {data?.product_type === "Product" && (
                <Grid container sx={{ mt: 2 }}>
                  <Grid xs={6} lg={3}>
                    <Typography className="gray" variant="body2" gutterBottom >
                      การคืนสินค้า
                    </Typography>
                  </Grid>
                  <Grid xs={6} lg={9}>
                    <Typography
                      variant="body2"
                      gutterBottom
                      dangerouslySetInnerHTML={{
                        __html: he.decode(
                          data?.product_refund_warranty_condition
                            ? data?.product_refund_warranty_condition
                            : 'ไม่มีการคืนสินค้า'
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              )}


              <Grid container sx={{ mt: 2 }}>
                {data?.product_type === "Service" ? (
                  <>
                    <Grid xs={6} lg={3}>
                      <Typography className="gray" variant="body2" gutterBottom >
                        เงื่อนไขการใช้งานบริการ
                      </Typography>
                    </Grid>
                    <Grid xs={6} lg={9}>
                      {data?.product_refund_warranty_condition ? (
                        <Typography variant="body2" gutterBottom>
                          {ReactHtmlParser(he.decode(data?.product_refund_warranty_condition).replace(/<\/?p>/g, ''))}

                        </Typography>

                      ) : (
                        <Typography variant="body2" gutterBottom>
                          ไม่มีเงื่อนไขการให้บริการ
                        </Typography>
                      )}
                    </Grid>


                  </>
                ) : (
                  <></>
                )}

              </Grid>

            </Box>
          ))}


          {getDataInfo && getDataInfo.products && getDataInfo.products.service_type === "4" ? (
            <React.Fragment key={getDataInfo.products.product_id}>
              <Grid container sx={{ ml: 2, mb: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom sx={{ ml: 1 }}>
                    วันหมดอายุ
                  </Typography>
                </Grid>
                <Grid xs={6} lg={9}>
                  <Typography variant="body2" gutterBottom>
                    {thaiDateFormat(he.decode(getDataInfo.products.service_expired_day
                      ? getDataInfo.products.service_expired_day
                      : "ไม่มีวันหมดอายุ").replace(/<\/?p>/g, ''))}
                  </Typography>
                </Grid>
              </Grid>
            </React.Fragment>
          ) : null}

          {getDataInfo && getDataInfo.products && getDataInfo.products.service_type === "3" ? (
            <React.Fragment key={getDataInfo.products.product_id}>
              <Grid container sx={{ ml: 2, mb: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom sx={{ ml: 1 }}>
                    วันหมดอายุ
                  </Typography>
                </Grid>
                <Grid xs={6} lg={9}>
                  {/* <Typography variant="body2" gutterBottom>
                    {parse(
                      getDataInfo.products.service_expired_day
                        ? getDataInfo.products.service_expired_day
                        : "ไม่มีวันหมดอายุ"
                    )}
                  </Typography> */}
                  <Typography variant="body2" gutterBottom>
                    {/* {getDataInfo.products.service_expired_day && isValid(new Date(getDataInfo.products.service_expired_day)) ?
                      parse(getDataInfo.products.service_expired_day) :
                      "ไม่มีวันหมดอายุ"
                    } */}
                    {thaiDateFormat(he.decode(getDataInfo.products.service_expired_day
                      ? getDataInfo.products.service_expired_day
                      : "ไม่มีวันหมดอายุ").replace(/<\/?p>/g, ''))}
                  </Typography>

                </Grid>
              </Grid>
            </React.Fragment>
          ) : null}


          {getDataInfo && getDataInfo.products && getDataInfo.products.service_type === "1" ? (
            <React.Fragment key={getDataInfo.products.product_id}>
              <Grid container sx={{ ml: 2, mb: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom sx={{ ml: 1 }}>
                    ระยะเวลาการจองล่วงหน้า/วัน
                  </Typography>
                </Grid>
                <Grid xs={6} lg={9}>
                  <Typography variant="body2" gutterBottom>
                    {ReactHtmlParser(
                      getDataInfo.products.service_booking_day
                        ? getDataInfo.products.service_booking_day
                        : "ไม่มีระยะเวลาการจองล่วงหน้า/วัน"
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container sx={{ ml: 2, mb: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom sx={{ ml: 1 }}>
                    ระยะเวลายกเลิกการจองล่วงหน้า/วัน
                  </Typography>
                </Grid>
                <Grid xs={6} lg={9}>
                  <Typography variant="body2" gutterBottom >
                    {getDataInfo.products.service_cancel_day === "Invalid date" ? (
                      "ไม่มีระยะเวลายกเลิกการจองล่วงหน้า/วัน"
                    ) : (
                      ReactHtmlParser(
                        getDataInfo.products.service_cancel_day
                          ? getDataInfo.products.service_cancel_day
                          : "ไม่มีระยะเวลายกเลิกการจองล่วงหน้า/วัน"
                      )
                    )}
                  </Typography>

                </Grid>
              </Grid>
              <Grid container sx={{ ml: 2, mb: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom sx={{ ml: 1 }}>
                    วันที่เริ่มใช้งาน
                  </Typography>
                </Grid>
                <Grid xs={6} lg={9}>
                  <Typography variant="body2" gutterBottom >
                    {getDataInfo.products.service_start_day === "Invalid date" ? (
                      "ไม่มีวันที่เริ่มใช้งาน"
                    ) : (
                      thaiDateFormat(
                        getDataInfo.products.service_start_day
                          ? getDataInfo.products.service_start_day
                          : "ไม่มีวันที่เริ่มใช้งาน"
                      )
                    )}
                  </Typography>

                </Grid>
              </Grid>
              <Grid container sx={{ ml: 2, mb: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom sx={{ ml: 1 }}>
                    วันหมดอายุ
                  </Typography>
                </Grid>
                <Grid xs={6} lg={9}>

                  <Typography variant="body2" gutterBottom >
                    {/* {getDataInfo.products.service_expired_day === "Invalid date" ? (
                      "ไม่มีวันหมดอายุ"
                    ) : (
                      ReactHtmlParser(
                        getDataInfo.products.service_expired_day
                          ? getDataInfo.products.service_expired_day
                          : "ไม่มีวันหมดอายุ"
                      )
                    )} */}
                    {thaiDateFormat(he.decode(getDataInfo.products.service_expired_day
                      ? getDataInfo.products.service_expired_day
                      : "ไม่มีวันหมดอายุ").replace(/<\/?p>/g, ''))}
                  </Typography>

                </Grid>
              </Grid>
            </React.Fragment>
          ) : null}

          {getDataInfo && getDataInfo.products && getDataInfo.products.service_type === "2" ? (
            <React.Fragment key={getDataInfo.products.product_id}>
              <Grid container sx={{ ml: 2, mb: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom sx={{ ml: 1 }}>
                    ระยะเวลาการจองล่วงหน้า/วัน
                  </Typography>
                </Grid>
                <Grid xs={6} lg={9}>
                  <Typography variant="body2" gutterBottom >
                    {ReactHtmlParser(
                      getDataInfo.products.service_booking_day
                        ? getDataInfo.products.service_booking_day
                        : "ไม่มีระยะเวลาการจองล่วงหน้า/วัน"
                    )}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container sx={{ ml: 2, mb: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom sx={{ ml: 1 }}>
                    ระยะเวลายกเลิกการจองล่วงหน้า/วัน
                  </Typography>
                </Grid>
                <Grid xs={6} lg={9}>
                  <Typography variant="body2" gutterBottom >
                    {getDataInfo.products.service_cancel_day === "Invalid date" ? (
                      "ไม่มีระยะเวลายกเลิกการจองล่วงหน้า/วัน"
                    ) : (
                      ReactHtmlParser(
                        getDataInfo.products.service_cancel_day
                          ? getDataInfo.products.service_cancel_day
                          : "ไม่มีระยะเวลายกเลิกการจองล่วงหน้า/วัน"
                      )
                    )}
                  </Typography>

                </Grid>
              </Grid>
              <Grid container sx={{ ml: 2, mb: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom sx={{ ml: 1 }}>
                    วันที่เริ่มใช้งาน
                  </Typography>
                </Grid>
                <Grid xs={6} lg={9}>
                  <Typography variant="body2" gutterBottom >
                    {getDataInfo.products.service_start_day === "Invalid date" ? (
                      "ไม่มีวันที่เริ่มใช้งาน"
                    ) : (
                      thaiDateFormat(
                        getDataInfo.products.service_start_day
                          ? getDataInfo.products.service_start_day
                          : "ไม่มีวันที่เริ่มใช้งาน"
                      )
                    )}
                  </Typography>

                </Grid>
              </Grid>
              <Grid container sx={{ ml: 2, mb: 2 }}>
                <Grid xs={6} lg={3}>
                  <Typography className="gray" variant="body2" gutterBottom sx={{ ml: 1 }}>
                    วันหมดอายุ
                  </Typography>
                </Grid>
                <Grid xs={6} lg={9}>

                  <Typography variant="body2" gutterBottom >
                    {/* {   getDataInfo.products.service_expired_day === "Invalid date" ? (
                      "ไม่มีวันหมดอายุ"
                    ) : (
                      ReactHtmlParser(
                           getDataInfo.products.service_expired_day
                          ?    getDataInfo.products.service_expired_day
                          : "ไม่มีวันหมดอายุ"
                      )
                    )} */}
                    {thaiDateFormat(he.decode(getDataInfo.products.service_expired_day
                      ? getDataInfo.products.service_expired_day
                      : "ไม่มีวันหมดอายุ").replace(/<\/?p>/g, ''))}
                  </Typography>

                </Grid>
              </Grid>
            </React.Fragment>
          ) : null}
        </TabPanel>
      </Card >
    </>
  );
}
